import { createBrowserHistory } from 'history';
import { logInfo, runInDevelopment } from './utils';

export const history = createBrowserHistory();
(() => runInDevelopment(() => history.listen(logInfo)))();
